// extracted by css-extract-rspack-plugin
export default {"cls1":"ResearchExamples-cls1_xgx","cls2":"ResearchExamples-cls2_KyP ResearchExamples-cls1_xgx"};